
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy/hulutender",
      function () {
        return require("private-next-pages/privacy/hulutender/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy/hulutender"])
      });
    }
  